<template>
  <div
    class="modal"
    id="presenterDetailModalVue"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-detail" role="document">
      <div class="modal-content text-black">
        <div class="modal-header">
          <h5 class="modal-title">Speaker Details</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- image -->
            <div class="col-md-4 dialog-speaker-image" v-if="presenter.photo">
              <img
                class="image"
                :src="presenter.photo"
                :alt="presenter.name"
              />
            </div>

            <!-- name and title -->
            <div :class="`${presenter.photo ? 'col-md-8' : 'col-md-12'} dialog-speaker-info`">
              <div class="block-info">
                <h6>Full Name: </h6>
                <strong>{{ presenter.name }}</strong>
                <div v-if="presenter.title">{{ presenter.title }}</div>
                <span v-if="presenter.role" class="badge badge-secondary">{{ presenter.role }}</span>
              </div>
            </div>

            <!-- description -->
            <div class="col-md-12 dialog-speaker-bio" v-if="presenter.bio">
              <div class="block-info">
                <h6>Speaker Bio: </h6>
                <p v-html="presenter.bio"></p>
              </div>
            </div>

            <!-- materials -->
            <div class="col-md-12" v-if="presenter?.materials?.length">
              <div class="block-info">
                <h6>Presentation Material{{presenter.materials > 1 ? 's' : ''}}:</h6>

                <ul class="list-group tickets">
                  <li
                    style="list-style-type: none;"
                    v-for="(file, fileIndex) in presenter.materials"
                    :key="`file-${fileIndex}`"
                  >
                <span class="pull-left" style="margin-top: 3px;">
                  <span :data-icon="file.icon_font_code" :class="`icon ${file.icon_font_code} fontcode`">&nbsp;</span>
                </span>

                    <div class="pull-left" style="margin:8px 0 0 10px;">
                      <a :href="file.url" target="_blank">{{ file.title }}</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    presenter: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
